import * as React from "react";
import {CONTACT_US_URL} from "../../../util/Constants"
import {authStore} from "../../common/authentication/AuthStore"

export const SSOUnauthorizedTeacher: React.FC<{}> = (props) => {
    return (
        <div>
            <div className="login__login-container" style={{display:"inline-block"}}>
                <div className="login__login-container__top">
                    <h2 style={{textAlign:"center"}}>SSOUnauthorizedTeacher</h2>
                    <p>
                        We're sorry, the Avant Assessment application has not been authorized by your district.  If you believe this is incorrect...
                    </p>
                    <p>
                        <a href={CONTACT_US_URL} target={"_blank"}>Contact Avant Assessment support</a>
                    </p>
                    <p>
                       {authStore &&authStore.auth && authStore.auth.ssoType=="ClassLink"?(<><a href={"https://help.classlink.com/s/technical-support"} target={"_blank"}>Contact Classlink support</a></>):(<><a href={"https://support.clever.com/"} target={"_blank"}>Contact Clever support</a></>)} 
                    </p>
                    <p>
                        To learn more about what Avant Assessment has to offer, why not start with our <a href={"https://avantassessment.com/sample-tests"} target={"_blank"}>sample tests</a>?
                    </p>
                </div>
            </div>
        </div>

    )
}
